import apiRequest from "../../helpers/apiRequest";

export default async () => {
    const res = await apiRequest({
        method: 'get',
        url: `accounts/partners`,
    });
    return res.data
}
